export default "__VITE_ASSET__326343b8__"